import React, { createContext, useReducer } from 'react';
import { appReducer } from './appReducer';

export const AppContext = createContext();

const LoadContextData = () => {
  const storedValue = localStorage.getItem("contextData");
  if (storedValue) {
    var data = JSON.parse(storedValue);
    if (data.loginTime) {
      var diff = (new Date()).getTime() - data.loginTime;
      if (diff < 30 * 24 * 60 * 60 * 1000)  {  // 8 hours = 8 * 60 * 60 * 1000
        return data;
      }
    }
  }
  return null;
}

const AppContextProvider = (props) => {

  let savedData = LoadContextData();
  
  var initData = savedData ? savedData : { 
    CurrentUser: null,
    Message: null,
    CurrentTheme: 'light',
  };

  const [appStore, dispatch] = useReducer(appReducer, [], () => {
     return initData;
  });

  return (
    <AppContext.Provider value={{ ...appStore, dispatch }}>
      {props.children}
    </AppContext.Provider>
  );
}

export default AppContextProvider;